import { render, staticRenderFns } from "./PropuestaTab.vue?vue&type=template&id=c38e47d4&scoped=true&lang=pug&"
import script from "./PropuestaTab.vue?vue&type=script&lang=js&"
export * from "./PropuestaTab.vue?vue&type=script&lang=js&"
import style0 from "./PropuestaTab.vue?vue&type=style&index=0&id=c38e47d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38e47d4",
  null
  
)

export default component.exports